import { select, call, put } from "redux-saga/effects";
import API from "../../API";
import {loadResponsesError, loadResponsesSuccess} from "./responses-action-creators";
import deepCopy from "../../utilities/deepCopy";
import {prepareFiltersToSend} from "../filters/functions";



export default function* loadResponses(action) {
  const { page, clean } = action;
  const reportUrl = yield select(state => state.report.reportUrl);
  const rawFilters = yield select(state => state.filters.filters);
  const scoreName = getScoreName(rawFilters);
  const filters = yield select(state => state.filters.filtersToSend);

  try {
    const result = yield call(API.loadResponses, {
      reportUrl,
      filters,
      page,
      scoreName
    });
    console.log(result.data.results, 'results');
    if (result.data.results && result.data.results.length) {
      const normalized = normalize(deepCopy(result.data.results));
      console.log(normalized, 'NORMALIZED RESPONSES');
      const totalPages = Math.ceil(result.data.responses_after_meta_filter / 20);
      yield put(loadResponsesSuccess({responses: normalized, page, totalPages, clean}))
    } else {
      yield put(loadResponsesError("No data"));
    }

  } catch(error) {
    console.log(error, 'ERROR FROM LOAD RESPONSES');
    yield put(loadResponsesError("Something went wrong..."))
  }
}

const normalize = data => {
  const result = data.map(d => d.columns[0]);
  result.forEach(d => {
    d.primaries = Object.keys(d.primaries).filter(p => d.primaries[p] > 0);
    d.hb_index = Number(d.hb_index).toFixed(3);
  });
  return result;
};

const emphazise = data => {
  data.forEach(d => {
    let value = d.value;
    for (let i=0; i < 40; i++) {
      d.primaries.push(d.primaries[0]);
      d.terms.push(d.terms[0])
      value += d.value;
    }
    d.value = value;
  })
};

const getScoreName = filters => {
  let scoreName;
  filters.forEach(filter => {
    filter.isScore ? scoreName = filter.filter_name : null;
  });
  !scoreName ? scoreName = "" : null;
  return scoreName;
};


// WEBPACK FOOTER //
// ./src/modules/responses/load-responses-saga.js